<template>
  <div>
    <PageAllow controller="Materials" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="8" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="name"
                v-model="keyword"
                @text="keyword = $event"
                :label="$t('Nav.materialsGroup')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="4" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
            </v-row>
          </v-col>
        </v-row>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="filteredMaterialGroups"
            :loading="loading"
            class="elevation-2 px-4 pt-1"
            hide-default-footer
          >
            <template v-slot:item.thumbnail="{ item }">
              <v-avatar
                v-if="item.thumbnail || item.img_url"
                tile
                color="bgGrey"
                style="vertical-align: top"
                class="my-1"
              >
                <v-menu open-on-hover :key="item.img_url">
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-bind="attrs"
                      v-on="on"
                      :src="
                        item.thumbnail
                          ? item.thumbnail
                          : item.img_url + '?x-image-process=style/160x160'
                      "
                    />
                  </template>
                  <v-img :src="item.img_url" width="160" />
                </v-menu>
              </v-avatar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="item.img_url"
                small
                dark
                color="primary"
                class="px-2 me-2 mb-1"
                @click.stop="
                  currentItem = item;
                  currentMode = 'read'
                  imageDialog = true;
                "
              >
                {{ $t("materialsGroup.viewOriginalImage") }}
              </v-btn>
              <v-btn
                small
                dark
                color="primary"
                class="px-2 me-2 mb-1"
                @click.stop="
                  currentItem = item;
                  currentMode = 'upload'
                  imageDialog = true;
                "
              >
                {{ $t("materialsGroup.uploadImage") }}
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <DialogImages
      v-model="imageDialog"
      :current-mode="currentMode"
      :current-item="currentItem"
      @success="getRecords"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import DialogImages from "./plugins/DialogImages.vue";
import Materials from "@/api/materials";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    DialogImages,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialManagement"),
        disabled: false,
        replace: true,
        href: "/materials",
      },
      {
        text: i18n.t("Nav.materialsGroup"),
        disabled: true,
        href: "/materials-group",
      },
    ],
    filteredMaterialGroups: function () {
      if (!this.searchKeyword) return this.materialGroups;
      return this.materialGroups.filter(function (item) {
        return item.material_group.indexOf(this.searchKeyword) !== -1;
      }.bind(this));
    },
    headers: () => [
      {
        text: i18n.t("Nav.materialsGroup"),
        align: "center",
        sortable: false,
        value: "material_group",
      },
      {
        text: i18n.t("materialsGroup.thumbnail"),
        align: "center",
        sortable: false,
        value: "thumbnail",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "center",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getRecords();
  },

  data: () => ({
    keyword: "",
    searchKeyword: "",
    materialGroups: [],
    currentItem: null,
    currentMode: '',
    imageDialog: false,
  }),

  methods: {
    resetSearch() {
      this.keyword = "";
      this.searchKeyword = "";
    },
    onSearch() {
      this.searchKeyword = this.keyword;
    },
    getRecords() {
      Materials.getMaterialGroupRecords().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materialGroups = response.data.material_groups;
          }
        }.bind(this)
      );
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>
